/**
 * remark plugin: turn literal HTML line breaks (`<br>`, `<br/>`, `<br />`) into real
 * markdown hard breaks. react-markdown deliberately does not render raw HTML, so
 * without this the tags print as text — most visibly inside GFM table cells, where
 * `<br>` is the only way an author (or the model) can break a line.
 */
const BR_RE = /<br\s*\/?>/i;
const BR_ALL = /<br\s*\/?>/gi;
const isBr = (value) => BR_RE.test(value) && !value.replace(BR_ALL, "").trim();

export default function remarkHtmlBreaks() {
  return (tree) => walk(tree);
}

function walk(node) {
  if (!Array.isArray(node.children)) return;
  const out = [];
  for (const child of node.children) {
    if (child.type === "html" && isBr(child.value)) {
      out.push({ type: "break" });
    } else if (child.type === "text" && BR_RE.test(child.value)) {
      child.value.split(BR_ALL).forEach((part, i) => {
        if (i > 0) out.push({ type: "break" });
        if (part) out.push({ type: "text", value: part });
      });
    } else {
      walk(child);
      out.push(child);
    }
  }
  node.children = out;
}
